import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import StoreBadges from "./StoreBadges";
import "../styles/DownloadModal.css";

const DownloadModal = ({ open, onClose }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden"; // lock scroll behind modal
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="download-modal-overlay" onClick={onClose}>
      <div
        className="download-modal"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="download-modal-close"
          onClick={onClose}
          aria-label={t(`Close`)}
        >
          ×
        </button>
        <h3 className="download-modal-title">
          {t(`Ready to find your match?`)}
        </h3>
        <p className="download-modal-text">
          {t(
            `Download Mabrook and start meeting Moroccans who are serious about marriage.`,
          )}
        </p>
        {/*<StoreBadges
          className="download-modal-badges"
          location="in Download Modal"
        />*/}
      </div>
    </div>
  );
};

export default DownloadModal;
